<template>
	<div class="edit-phone">
		<div class="edit-form">
			<label>当前手机号码</label>
			{{userInfo.moblie}}
		</div>
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="115px" class="demo-ruleForm yq" label-position="left">
			<el-form-item label="新手机号码" prop="mobile">
				<el-input v-model="ruleForm.mobile"></el-input>
			</el-form-item>
			<el-form-item label="图片验证码" prop="imgCode" :error="errMessage">
				<el-input placeholder="请输入图片验证码" v-model="ruleForm.imgCode" class="hint-input-code">
					<template slot="append">
						<img :src="'/user/manager/image?count='+count" alt @click="count++"/>
					</template>
				</el-input>
			</el-form-item>
			<el-form-item label="验证码" prop="code">
				<el-input v-model="ruleForm.code"></el-input>
				<span class="edit-form-span edit-code" @click="sendSmsCode" :class="countDown?'edit-cod2':''">{{countDown? countDown+'秒':'获取验证码'}}</span>
			</el-form-item>
		</el-form>
		<div class="formbtn" @click="submitForm('ruleForm')">保存</div>
	</div>
</template>

<script>
import validate from '../../store/validate.js'
import rules from '../../store/rules.js'
import {
	mapGetters,
	mapActions
} from 'vuex'

export default {
	name: 'accountEditPhone',
	data () {
		var validatemPhone2 = (rule, value, callback) => {
			this.getCheckPhone({
				mobile: this.ruleForm.mobile
			}).then(data => {
				if (data.data.isSuccess) {
					callback()
				} else {
					callback(new Error('手机号码已注册过站神账号'))
				}
			})
		}
		return {
			count: 0,
			countDown: 0,
			ruleForm: {
				mobile: '',
				imgCode: '',
				code: ''
			},
			rules: {
				...rules,
				imgCode: [{
					required: true,
					message: '请输入图片验证码',
					trigger: 'blur'
				}],
				mobile: [{
					required: true,
					message: '请输入手机号码',
					trigger: 'blur'
				},
				{
					validator: validate.validatemphone,
					trigger: 'blur'
				},
				{
					validator: validatemPhone2,
					trigger: 'blur'
				},
				]
			},
			errMessage: ''
		}
	},
	methods: {
		...mapActions('user', ['getUserCode', 'getUpdateMobile', 'getCheckPhone']),
		submitForm (formName) {
			this.$refs[formName].validate(valid => {
				if (!valid) return
				let params = {
					username: this.userInfo.username,
					mobile: this.ruleForm.mobile
				}
				this.getUpdateMobile(params).then(res => {
					if (res.data.isSuccess) {
						let This = this
						this.$message({
							message: res.data.message,
							type: 'success'
						})
						setTimeout(function () {
							This.$emit('Close')
						}, 2000)
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						})
					}
				})
			})
		},
		//验证码获取
		sendSmsCode () {
			this.$refs.ruleForm.validateField('mobile', err => {
				if (err) {
					return
				}
				this.$refs.ruleForm.validateField('imgCode', (err) => {
					if (err) {
						return
					}
					if (this.countDown) {
						this.$message({
							message: '1分钟内不能重复发送验证码！',
							type: 'error'
						})
						return
					}
					this.getUserCode({
						mobile: this.ruleForm.mobile,
						code: this.ruleForm.imgCode
					}).then(
						data => {
							if (!data.data.isSuccess) {
								this.errMessage = data.data.message
							} else {
								this.countDown = 60
								let interval
								this.$message({
									message: data.data.message,
									type: 'success'
								})
								interval = setInterval(() => {
									this.countDown--
									if (!this.countDown) {
										clearInterval(interval)
									}
								}, 1000)
							}
						}
					)
				})
			})
		}
	},
	computed: {
		...mapGetters('user', ['userInfo'])
	}
}

</script>


<style lang="scss" scoped>
.edit-form {
	margin-bottom: 29px;
	label {
		display: inline-block;
		width: 110px;
		line-height: 32px;
	}

	.el-input {
		display: inline-block;
		width: 245px;
	}
}

.edit-form-span {
	display: inline-block;
	margin-left: 30px;
	color: #e80000;
	line-height: 14px;

	&.edit-code {
		color: #0686d8;
		border-bottom: 1px solid #0686d8;
		cursor: pointer;

		&.edit-cod2 {
			color: #858585;
			border: 0;
		}
	}

	&.password-point {
		color: #c1c1c1;
	}
}

.formbtn {
	margin: 30px 0 44px 115px;
}

.el-input {
	width: 245px;
}
.el-form-item__content{
	line-height: 32px;
}
.el-input__inner{
	height: 32px;
}
</style>
